//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

 
import UMUM from  '../../library/umum.js'
import FETCHING from  '../../library/fetching'
import WILAYAH from  '../../library/getWilayah'
import uniqid from 'uniqid';

 

export default { 
    data () {
        return {
            FETCHING:FETCHING, 
            token : localStorage.token,               
            terbitkanSurat:false, 

            filterby:'',
            options_filterby :[{status:'-', nilai:''}, {status:'Diterima', nilai:true}, {status:'Ditolak', nilai:false}],

            option_status : [{id  : 0, uraian : 'Proses'}, {id  : 1, uraian : 'Diterima'}, {id  : 2, uraian : 'Dikembalikan'}],

            shape: '',
            permohonan_ktp:'', 
            dense:true, 
            current : 1, 
            model: '', 
            
            nama_prov:'',
            nama_kab:'',
            nama_kec:'',
            nama_des_kel:'',            

            form_email:{
              file_terbit    :null,
              from    : "",
              to      : "",
              subject : "",
              text    : "",
              html    : "",
            },

            form: {
              

              id                : '',
              m_provinsi        : '74',
              m_kabupaten       : '7405',
              m_kecamatan       : '',
              m_desa_kelurahan  : '',              
              
              modul:'ktp',

              permohonan_ktp: '', 
              file: null, 
              nama: '', 
              no_kk: '', 
              nik: '', 
              alamat: '', 
              rt: '', 
              rw: '', 
              kode_pos: '', 

                status : 0,
                keterangan : 0,
                
                keterangan_deskel:'',
                keterangan_kecamatan:'',
                keterangan_kabupaten  :'',

                status_deskel:0,
                status_kecamatan:0,
                status_kabupaten  :0,

                createdBy : '',
                createdAt : '',
                createdAt_deskel:'',
                createdAt_kecamatan:'',
                createdAt_kabupaten  :'',

              file_terbitan : null,
              emailPemohon:'',

              email_file     :null,
              email_fileOld  :'',

              email_from     :'',
              email_to       :'',
              email_subject  :'',
              email_html     :'',
              file_lampiran     :null,
              file_lampiranOld  : null
            },

            fileOld : '',
            fileOldThumb : '',

            wilayah : {
              uraian_provinsi : '',
              kd_provinsi : 74,
              uraian_kabupaten : '',
              kd_kabupaten : '',
              uraian_kecamatan : '',
              kd_kecamatan : '',
              uraian_desa_kelurahan : '',
              kd_desa_kelurahan : '',
            },

            list_data : [],
            list_data_kecamatan : [],
            list_data_kabupaten : [],

            page_limit : 5,
            page_first: 1,
            page_last: 0,
            cari_value: "",
            cek_load_data : true,
            UMUM : UMUM,

        }
    },
    methods: {

      // ============================= USERS =============================
        clearData(){
            this.form.id                       = ""
            this.form.m_provinsi               = "74"
            this.form.m_kabupaten              = "7405"
            this.form.m_kecamatan              = ""
            this.form.m_desa_kelurahan         = ""
                     
            this.form.modul                    = ""
            this.form.permohonan_ktp           = ""
            this.form.nama                     = ""
            this.form.no_kk                    = ""
            this.form.nik                      = ""
            this.form.alamat                   = ""
            this.form.rt                       = ""
            this.form.rw                       = ""
            this.form.kode_pos                 = ""
            this.form.status_deskel            = ""
            this.form.status_kecamatan         = ""
            this.form.status_kabupaten         = ""
            this.form.keterangan_deskel        = ""
            this.form.keterangan_kecamatan     = ""
            this.form.keterangan_kabupaten     = ""
            this.form.status                   = ""
            this.form.keterangan               = ""
            this.form.createdAt                = ""
            this.form.createdBy                = ""
            this.form.emailPemohon             = ""
            this.form.file_lampiran            = ""
            this.form.file_lampiranOld         = "" 
            this.form.email_fileOld            = ""
            this.form.email_from               = ""
            this.form.email_to                 = ""
            this.form.emailPemohon             = ""
            this.form.email_subject            = ""
            this.form.email_html               = ""
            this.fileOld                       = ""
            this.fileOldThumb                  = ""
            this.wilayah                       = ""
           
        },
        getView : function(){
          // this.$store.commit("shoWLoading");
          fetch(this.$store.state.url.URL_PERMOHONAN_KTP + "view", {
              method: "POST",
              headers: {
              "content-type": "application/json",
              authorization: "kikensbatara " + localStorage.token
              },
              body: JSON.stringify({
                  data_ke: this.page_first,
                  page_limit : this.page_limit,
                  cari_value: this.cari_value,
                  createdBy : this.$store.state.lcProfile.id
              })
            })
              .then(res => res.json())
              .then(res_data => { 
                  this.list_data = res_data.data;
                  this.page_last = res_data.jmlData; 
                  console.log(res_data.data);
          });
        },

        validateForm: function() {
          const f = this.form;

          // ========== DAERAH TUJUAN PERMOHONAN ==========
          if (!f.m_provinsi || f.m_provinsi === '') {
            this.$q.notify({ type: 'negative', message: 'Pilih provinsi tujuan permohonan.' });
            return false;
          }
          if (!f.m_kabupaten || f.m_kabupaten === '') {
            this.$q.notify({ type: 'negative', message: 'Pilih kabupaten tujuan permohonan.' });
            return false;
          }
          if (!f.m_kecamatan || f.m_kecamatan === '') {
            this.$q.notify({ type: 'negative', message: 'Pilih kecamatan tujuan permohonan.' });
            return false;
          }
          if (!f.m_desa_kelurahan || f.m_desa_kelurahan === '') {
            this.$q.notify({ type: 'negative', message: 'Pilih desa/kelurahan tujuan permohonan.' });
            return false;
          }

          // ========== PERMOHONAN KTP & FILE UTAMA ==========
          if (!f.permohonan_ktp || f.permohonan_ktp === '') {
            this.$q.notify({ type: 'negative', message: 'Pilih jenis permohonan KTP (Baru / Penggantian).' });
            return false;
          }
          if (!f.file || f.file === '') {
            const labelFile = f.permohonan_ktp === 'Baru' ? 'Scan Kartu Keluarga (*Jpg)' : 'Foto KTP';
            this.$q.notify({ type: 'negative', message: `Upload file ${labelFile} wajib diisi.` });
            return false;
          }

          // ========== DATA PEMOHON ==========
          if (!f.nama || f.nama.toString().trim() === '') {
            this.$q.notify({ type: 'negative', message: 'Nama lengkap wajib diisi.' });
            return false;
          }
          if (!f.no_kk || f.no_kk.toString().trim() === '') {
            this.$q.notify({ type: 'negative', message: 'Nomor kartu keluarga wajib diisi.' });
            return false;
          }
          if (!f.nik || f.nik.toString().trim() === '') {
            this.$q.notify({ type: 'negative', message: 'NIK wajib diisi.' });
            return false;
          }
          if (!f.alamat || f.alamat.toString().trim() === '') {
            this.$q.notify({ type: 'negative', message: 'Alamat wajib diisi.' });
            return false;
          }
          if (f.rt === '' || f.rt === null || f.rt === undefined) {
            this.$q.notify({ type: 'negative', message: 'RT wajib diisi.' });
            return false;
          }
          if (f.rw === '' || f.rw === null || f.rw === undefined) {
            this.$q.notify({ type: 'negative', message: 'RW wajib diisi.' });
            return false;
          }
          if (!f.kode_pos || f.kode_pos.toString().trim() === '') {
            this.$q.notify({ type: 'negative', message: 'Kode pos wajib diisi.' });
            return false;
          }

          // ========== LAMPIRAN FILE ==========
          if (!f.file_lampiran || f.file_lampiran === '') {
            this.$q.notify({ type: 'negative', message: 'File lampiran (PDF) wajib diisi.' });
            return false;
          }

          return true;
        },
        add_data:function(){
          // Jalankan validasi sebelum submit
          if (!this.validateForm()) {
            return;
          }

          this.$store.state.modal_loading = true;


          // var email_from          = this.$store.state.lcProfile.email 
          var email_pemohon       = this.$store.state.lcProfile.email 
          this.form.emailPemohon  = email_pemohon
          console.log(email_pemohon);

          var formData = new FormData(); 
          formData.append("id", uniqid());
          formData.append("m_provinsi", this.form.m_provinsi);
          formData.append("m_kabupaten", this.form.m_kabupaten);
          formData.append("m_kecamatan", this.form.m_kecamatan);
          formData.append("m_desa_kelurahan", this.form.m_desa_kelurahan);
          formData.append("modul", this.form.modul);
          formData.append("permohonan_ktp", this.form.permohonan_ktp);
          formData.append("file", this.form.file);

          formData.append("nama", this.form.nama);
          formData.append("no_kk", this.form.no_kk);
          formData.append("nik", this.form.nik);
          formData.append("alamat", this.form.alamat);
          formData.append("rt", this.form.rt);
          formData.append("rw", this.form.rw);
          formData.append("kode_pos", this.form.kode_pos); 

          formData.append( "status", this.form.status);
          formData.append( "keterangan", this.form.keterangan);
          formData.append( "keterangan_deskel", this.form.keterangan_deskel);
          formData.append( "keterangan_kecamatan", this.form.keterangan_kecamatan);
          formData.append( "keterangan_kabupaten", this.form.keterangan_kabupaten);
          formData.append( "status_deskel", this.form.status_deskel);
          formData.append( "status_kecamatan", this.form.status_kecamatan);
          formData.append( "status_kabupaten", this.form.status_kabupaten);
          formData.append( "createdAt", UMUM.NOW());
          formData.append( "createdAt_deskel", this.form.createdAt_deskel);
          formData.append( "createdAt_kecamatan", this.form.createdAt_kecamatan);
          formData.append( "createdAt_kabupaten", this.form.createdAt_kabupaten);

 
          formData.append("emailPemohon", this.form.emailPemohon);


          
          formData.append("file_lampiran", this.form.file_lampiran);


          fetch(this.$store.state.url.URL_PERMOHONAN_KTP + "addData", {
              method: "POST",
              headers: {
                  // "content-type": "application/json",
                  authorization: "kikensbatara " + localStorage.token
              },
              body: formData
          }).then(res_data => {
              // this.Notify('Sukses Menambah Data', 'primary', 'check_circle_outline');
              // console.log(res_data);
              this.$store.state.modal_loading = false;
              this.$store.commit('notif_berhasil')
              this.getView();
          });
          
        },

        editData : function(){
          this.$store.state.modal_loading = true;

          var formData = new FormData(); 
          formData.append("id", this.form.id);
          formData.append("m_provinsi", this.form.m_provinsi);
          formData.append("m_kabupaten", this.form.m_kabupaten);
          formData.append("m_kecamatan", this.form.m_kecamatan);
          formData.append("m_desa_kelurahan", this.form.m_desa_kelurahan);
          formData.append("modul", this.form.modul);
          formData.append("permohonan_ktp", this.form.permohonan_ktp);
          formData.append("file", this.form.file); 
          formData.append("nama", this.form.nama);
          formData.append("no_kk", this.form.no_kk);
          formData.append("nik", this.form.nik);
          formData.append("alamat", this.form.alamat);
          formData.append("rt", this.form.rt);
          formData.append("rw", this.form.rw);
          formData.append("kode_pos", this.form.kode_pos); 

          formData.append( "status", this.form.status);
          formData.append( "keterangan", this.form.keterangan);
          formData.append( "keterangan_deskel", this.form.keterangan_deskel);
          formData.append( "keterangan_kecamatan", this.form.keterangan_kecamatan);
          formData.append( "keterangan_kabupaten", this.form.keterangan_kabupaten);
          formData.append( "status_deskel", this.form.status_deskel);
          formData.append( "status_kecamatan", this.form.status_kecamatan);
          formData.append( "status_kabupaten", this.form.status_kabupaten);
          formData.append( "createdAt", this.form.createdAt);
          formData.append( "createdAt_deskel", this.form.createdAt_deskel);
          formData.append( "createdAt_kecamatan", this.form.createdAt_kecamatan);
          formData.append( "createdAt_kabupaten", this.form.createdAt_kabupaten);

          formData.append("fileOld", this.fileOld); 
          formData.append("emailPemohon", this.form.emailPemohon); 
          formData.append("file_lampiran", this.form.file_lampiran);
          formData.append("file_lampiranOld", this.form.file_lampiranOld);


          fetch(this.$store.state.url.URL_PERMOHONAN_KTP + "editData", {
              method: "POST",
              headers: {
                // "content-type": "application/json",
                authorization: "kikensbatara " + localStorage.token
              },
              body: formData
          }).then(res_data => {
              // this.Notify('Sukses Merubah Data', 'warning', 'check_circle_outline');
              this.$store.state.modal_loading = false;
              this.$store.commit('notif_edit');
              this.getView();
          });
        },
        removeData : function(E){
          this.$store.state.modal_loading = true;
          fetch(this.$store.state.url.URL_PERMOHONAN_KTP + "removeData", {
              method: "POST",
              headers: {
                "content-type": "application/json",
                authorization: "kikensbatara " + localStorage.token
              },
              body: JSON.stringify({
                  id : this.form.id,
                  fileOld : this.fileOld,
                  fileOldThumb : this.fileOldThumb,
                  file_lampiranOld : this.form.file_lampiranOld
              })
          }).then(res_data => {
              this.$store.state.modal_loading = false;
              this.$store.commit('notif_berhasil_menghapus');
              this.getView();
          });

        }, 
        selectData : function(data){ 
            
            console.log(data); 

            this.form.id = data.permohonan_KTP.id;
            this.form.m_provinsi = data.permohonan_KTP.m_provinsi;
            this.form.m_kabupaten = data.permohonan_KTP.m_kabupaten;
            this.form.m_kecamatan = data.permohonan_KTP.m_kecamatan;
            this.form.m_desa_kelurahan = data.permohonan_KTP.m_desa_kelurahan;   
                     
            this.form.modul = data.permohonan_KTP.modul;
            this.form.permohonan_ktp = data.permohonan_KTP.permohonan_ktp;
            this.form.nama = data.permohonan_KTP.nama;
            this.form.no_kk = data.permohonan_KTP.no_kk; 
            this.form.nik = data.permohonan_KTP.nik;
            this.form.alamat = data.permohonan_KTP.alamat;
            this.form.rt = data.permohonan_KTP.rt;
            this.form.rw = data.permohonan_KTP.rw;
            this.form.kode_pos = data.permohonan_KTP.kode_pos;

            this.form.status_deskel = data.permohonan_KTP.status_deskel;
            this.form.status_kecamatan = data.permohonan_KTP.status_kecamatan;
            this.form.status_kabupaten = data.permohonan_KTP.status_kabupaten;
            this.form.keterangan_deskel = data.permohonan_KTP.keterangan_deskel;
            this.form.keterangan_kecamatan = data.permohonan_KTP.keterangan_kecamatan;
            this.form.keterangan_kabupaten  = data.permohonan_KTP.keterangan_kabupaten;
            this.form.status = data.permohonan_KTP.status;
            this.form.keterangan = data.permohonan_KTP.keterangan;
            this.form.createdAt = data.permohonan_KTP.createdAt;
            this.form.createdBy = data.permohonan_KTP.createdBy;

            this.form.emailPemohon      = data.permohonan_KTP.emailPemohon;
            this.form.file_lampiran     = data.permohonan_KTP.file_lampiran;
            this.form.file_lampiranOld  = data.permohonan_KTP.file_lampiranOld;
            
          // this.form.email_file    = data.permohonan_KTP.email_file;
          this.form.email_fileOld = data.permohonan_KTP.email_file;
          this.form.email_from    = this.form.email_from;
          this.form.email_to      = this.form.emailPemohon;
          this.form.email_subject = data.permohonan_KTP.email_subject;
          this.form.email_html    = data.permohonan_KTP.email_html;
          
          this.fileOld            = data.permohonan_KTP.file;
          this.fileOldThumb       = data.permohonan_KTP.fileThumb;

          this.wilayah = {
            uraian_provinsi : data.m_provinsi.uraian,
            kd_provinsi : data.m_provinsi.kd_provinsi,
            uraian_kabupaten : data.m_kabupaten.uraian,
            kd_kabupaten : data.m_kabupaten.kd_kabupaten,
            uraian_kecamatan : data.m_kecamatan.uraian,
            kd_kecamatan : data.m_kecamatan.kd_kecamatan,
            uraian_desa_kelurahan : data.m_desa_kelurahan.uraian,
            kd_desa_kelurahan : data.m_desa_kelurahan.kd_desa_kelurahan,
          };  

        },


        cekButton_status_kecamatan: function(data){  
          var a = data.permohonan_KTP.status 
          var status_kab = data.permohonan_KTP.status_kabupaten  
          if (this.$store.state.lcProfile.kelas == 'op_vertikal') {
            if (status_kab == 1) {
              return true
            }
            return false
          }else{
            if (a == 1) {
              return true
            }else{
              return false
            }
          }  
        },
      // ============================= USERS =============================

      // ============================= KECAMATAN =============================
        getViewKecamatan : function(){
          // this.$store.commit("shoWLoading");
          fetch(this.$store.state.url.URL_PERMOHONAN_KTP + "viewKecamatan", {
              method: "POST",
              headers: {
              "content-type": "application/json",
              authorization: "kikensbatara " + localStorage.token
              },
              body: JSON.stringify({
                  data_ke: this.page_first,
                  page_limit : this.page_limit,
                  cari_value: this.cari_value,
                  status_kecamatan : this.form.status_kecamatan,
                  pl_provinsi       :this.$store.state.lcProfile.provinsi,
                  pl_kabupaten      :this.$store.state.lcProfile.kabupaten,
                  pl_kecamatan      :this.$store.state.lcProfile.kecamatan,
              })
            })
              .then(res => res.json())
              .then(res_data => {
                // console.log("TAAAAAAAAAAIIIIIIII")
                  this.list_data_kecamatan = res_data.data;
                  this.page_last = res_data.jmlData;
                  // this.$store.commit("hideLoading");
                  console.log("INI KECAMATAN")
                  console.log(res_data);
          });
        },


        editDataKecamatan : function(status){
          // console.log(status)
          this.$store.state.modal_loading = true;

          fetch(this.$store.state.url.URL_PERMOHONAN_KTP + "editDataKecamatan", {
              method: "POST",
              headers: {
                "content-type": "application/json",
                authorization: "kikensbatara " + localStorage.token
              },
              body: JSON.stringify({
                id : this.form.id,
                keterangan_kecamatan : this.form.keterangan_kecamatan,
                createdAt_kecamatan : UMUM.NOW(),
                kategorix : status
              })
          }).then(res_data => {
              this.$store.state.modal_loading = false;
              this.$store.commit('notif_edit');
              this.getViewKecamatan();
          });
        },

      // ============================= KECAMATAN =============================

      // ============================= KABUPATEN =============================
        getViewKabupaten : function(){
          // this.$store.commit("shoWLoading");
          fetch(this.$store.state.url.URL_PERMOHONAN_KTP + "viewKabupaten", {
              method: "POST",
              headers: {
              "content-type": "application/json",
              authorization: "kikensbatara " + localStorage.token
              },
              body: JSON.stringify({
                  data_ke: this.page_first,
                  page_limit : this.page_limit,
                  cari_value: this.cari_value,
                  status_kabupaten : this.form.status_kabupaten
              })
            })
              .then(res => res.json())
              .then(res_data => {
                // console.log("TAAAAAAAAAAIIIIIIII")
                  this.list_data_kabupaten = res_data.data;
                  this.page_last = res_data.jmlData;
                  // this.$store.commit("hideLoading");
                  console.log(res_data);
          });
        }, 
        editDataKabupaten : function(status){
          this.$store.state.modal_loading = true;
          console.log("SA DI CLICK")
          fetch(this.$store.state.url.URL_PERMOHONAN_KTP + "editDataKabupaten", {
              method: "POST",
              headers: {
                "content-type": "application/json",
                authorization: "kikensbatara " + localStorage.token
              },
              body: JSON.stringify({
                id : this.form.id,
                keterangan_kabupaten : this.form.keterangan_kabupaten,
                createdAt_kabupaten : UMUM.NOW(),
                kategorix : status
              })
          }).then(res_data => {
              this.$store.state.modal_loading = false;
              this.$store.commit('notif_edit');
              this.getViewKabupaten();
          });
        }, 

        terbit_file_Kabupaten : function(){
          this.$store.state.modal_loading = true;
          console.log(this.form.email_fileOld);
          var formData = new FormData();
          formData.append("id", this.form.id);
          formData.append("email_file", this.form.email_file); 
          formData.append("email_fileOld", this.form.email_fileOld); 
          formData.append("email_from", this.form.email_from)
          formData.append("email_to", this.form.email_to)
          formData.append("email_subject", this.form.email_subject) 
          formData.append("email_html", this.form.email_html)
          

          fetch(this.$store.state.url.URL_PERMOHONAN_KTP + "file_terbitan_Kabupaten", {
              method: "POST",
              headers: {
                // "content-type": "application/json",
                authorization: "kikensbatara " + localStorage.token
              },
              body: formData,
          }).then(res_data => { 
              this.wa_notif()
              this.$store.state.modal_loading = false;
              this.$store.commit('notif_terbit');
              this.getView();
          });
        },
      // ============================= KABUPATEN =============================
      
      

      bukaTab(linknya){
        window.open(linknya);
      },



      // ====================================== filter autocomplete  
          renderChildProv(data) {
              return `
              <span><b>${data.kd_provinsi}</b></span>
              <span style='font-size:80%'>${data.uraian}</span>
              `
          },

          renderChildKab(data) {
              return `
              <span><b>${data.kd_kabupaten}</b></span>
              <span style='font-size:80%'>${data.uraian}</span>
              `
          },

          renderChildKec(data) {
              return `
              <span><b>${data.kd_kecamatan}</b></span>
              <span style='font-size:80%'>${data.uraian}</span>
              `
          },

          renderChild_des_kel(data) {
              return `
              <span><b>${data.kd_desa_kelurahan}</b></span>
              <span style='font-size:80%'>${data.uraian}</span>
              `
          },

          get_auto(data){
            this.form.m_provinsi = data.m_provinsi  
            console.log(data.kd_provinsi); 
          },

          get_auto_kab(data){ 
            this.form.m_kabupaten = data.m_kabupaten 
            console.log(data.kd_kabupaten); 
          },

          get_auto_kec(data){ 
            this.form.m_kecamatan = data.m_kecamatan 
            console.log(data.kd_kecamatan); 
          },

          get_auto_des_kel(data){ 
            this.form.m_desa_kelurahan = data.m_desa_kelurahan 
            console.log(data.kd_desa_kelurahan); 
          },        
      // ====================================== filter autocomplete       

      CariData(){
        this.getView();
        // console.log(this.$store.state.lcProfile.kelas)

        if (this.$store.state.lcProfile.kelas == 'kecamatan') {
          this.getViewKecamatan()
        } else if (this.$store.state.lcProfile.kelas == 'kabupaten'){
          this.getViewKabupaten()
        }


      },

      

      counterLabelFn ({ totalSize, filesNumber, maxFiles }) {
        return `${filesNumber} files of ${maxFiles} | ${totalSize}`
      },   

      check_nomor(no){
        // Replace +62 or 62 with 0
        let phoneNumber = "+6281626883162";
        let newPhoneNumber = phoneNumber.replace(/(\+62|62)/, "0");
        console.log(newPhoneNumber); 
        // Output: 081356883162
      },

      async wa_notif(){
        var data = await this.FETCHING.fetch_postx(this.$store.state.url.URL_WA_API+'send_wa' , JSON.stringify({
          createdBy : this.form.createdBy,
          pesan     : 'KTP'
        }))
        console.log(data);
      },

    },

    mounted () {
      // this.check_nomor()
      this.CariData();
      this.$store.state.lcProfile.kelas
      this.$store.state.lcProfile.id
      var email_from          = this.$store.state.lcProfile.email 
      var email_pemohon       = this.$store.state.lcProfile.email 
      console.log(email_pemohon);
      this.form.emailPemohon  = email_pemohon
      email_from = this.form.email_from;
      this.$store.state.lcProfile.kelas
      console.log(email_from);
    },


}
